import type { AgentConfig } from "~/shared/types";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Cursor",
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#CCCCCC",
  helpUrl: "https://help.dartai.com/en/articles/12341238-ai-coding-agent-with-cursor-background-agents",
  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "API Key",
      placeholder: "Your Cursor API key",
    },
    {
      type: "text",
      key: "repository",
      label: "GitHub Repo URL",
      placeholder: "https://github.com/organization/repository",
    },
  ],
};

export default config;
